import { useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/format";
import { toast } from "sonner";

export function RecordPayout({ onUpdated }) {
  const [amount, setAmount] = useState("");
  const [busy, setBusy] = useState(false);
  const n = Number(amount);
  const valid = n > 0 && Number.isFinite(n);
  const submit = async () => {
    if (!valid || busy) return;
    setBusy(true);
    try {
      await api.post("/sentence/pot/payout", { amount: n });
      toast.success("pot updated");
      setAmount("");
      onUpdated();
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="mt-8 pt-6" style={{ borderTop: "1px solid var(--border)" }} data-testid="pot-payout-section">
      <label className="text-xs uppercase tracking-widest" style={{ color: "var(--text-muted)" }}>member · record a payout (CAD)</label>
      <div className="flex gap-3 mt-2">
        <input data-testid="pot-payout-input" type="number" min={0} step="0.01" value={amount} onChange={(e) => setAmount(e.target.value)} className="flex-1 px-4 py-2" style={{ background: "transparent", border: "1px solid var(--border)", color: "var(--text-primary)" }} />
        <button onClick={submit} disabled={!valid || busy} data-testid="pot-payout-btn" className="btn px-5 py-2 text-xs tracking-widest">{busy ? "…" : "DEDUCT"}</button>
      </div>
    </div>
  );
}

export function DrawPotModal({ onClose, onUpdated }) {
  const { user } = useAuth();
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-6 fade-in" style={{ background: "rgba(0,0,0,0.75)" }} onClick={onClose} data-testid="draw-pot-overlay">
      <div className="w-full max-w-md p-8" style={{ background: "var(--bg-modal)", border: "1px solid var(--border)" }} onClick={(e) => e.stopPropagation()} data-testid="draw-pot-modal">
        <div className="flex justify-between items-start mb-6">
          <span className="text-xs uppercase tracking-widest" style={{ color: "var(--text-muted)" }}>draw on the pot</span>
          <button onClick={onClose} data-testid="draw-pot-close" className="text-sm opacity-60 hover:opacity-100" style={{ color: "var(--text-primary)" }}>[ close ]</button>
        </div>
        <p className="text-base leading-relaxed" style={{ color: "var(--text-secondary)" }} data-testid="draw-pot-message">
          contact <a href="mailto:foundation@mawilu.com" style={{ color: "var(--accent)" }} data-testid="draw-pot-email">foundation@mawilu.com</a> to apply for pot funding
        </p>
        {user?.is_god && <RecordPayout onUpdated={onUpdated} />}
      </div>
    </div>
  );
}
